// extracted by mini-css-extract-plugin
export default {"root":"_3f1ox","stat":"_34RGi","label":"_3fZQH"};